import {
  AppBar,
  Toolbar,
  Typography,
  Tooltip,
  IconButton,
  MenuItem,
  Menu,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  Box,
  TextField,
} from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import { styled } from "@mui/material/styles";
import Badge from "@mui/material/Badge";
import Avatar from "@mui/material/Avatar";

import UserAvatar from "../components/UserAvatar";
import {
  MenuOpen as MenuOpenIcon,
  Menu as MenuIcon,
  Logout as LogoutIcon,
  Person as PersonIcon,
} from "@mui/icons-material";
//Avatar
import { userData } from "../config";
import Link from "@mui/material/Link";
import { useNavigate } from "react-router-dom";
import { handleLogout } from "../commonFunctions/logout";

import NotificationsIcon from "@mui/icons-material/Notifications";
import { fetchPendingCreditApprovalsAPI, approveCreditApprovalAPI } from "../config";
import { apiData } from "../services/api_service";

function Header(props) {
  const [appBarPosition, setAppBarPosition] = useState("static");
  const [userName, setUserName] = useState("Test");
  const [userEmail, setUserEmail] = useState("test@gmail.com");
  const [anchorEl, setAnchorEl] = useState(null);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [notificationsAnchor, setNotificationsAnchor] = useState(null);
  const [pendingApprovals, setPendingApprovals] = useState([]);
  const [customDaysModal, setCustomDaysModal] = useState({
    open: false,
    req: null,
    days: "",
    loading: false,
  });

  const open = Boolean(anchorEl);
  const isNotificationOpen = Boolean(notificationsAnchor);

  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const isAdmin = [295, 377].includes(Number(user?.role_id));

  const fetchNotifications = useCallback(async () => {
    if (!isAdmin) return;
    try {
      const res = await apiData("get", fetchPendingCreditApprovalsAPI);
      if (res.success && res.data?.result) {
        setPendingApprovals(res.data.result);
      }
    } catch (err) {
      console.error("Failed to fetch pending credit notifications:", err);
    }
  }, [isAdmin]);

  useEffect(() => {
    const userObj = JSON.parse(localStorage.getItem("user") || "{}");
    if (userObj) {
      setUserName(userObj.username);
      setUserEmail(userObj.email);
    }

    if (isAdmin) {
      fetchNotifications();
      const interval = setInterval(fetchNotifications, 30000);
      return () => clearInterval(interval);
    }

    function handleTransparentNavbar() {
      if (window.scrollY === 0) {
        setAppBarPosition("static");
      }
    }

    window.addEventListener("scroll", handleTransparentNavbar);
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [isAdmin, fetchNotifications]);

  const [readIds, setReadIds] = useState(() => {
    try {
      const parsed = JSON.parse(localStorage.getItem("read_credit_notifications") || "[]");
      return Array.isArray(parsed) ? parsed.map(Number) : [];
    } catch (e) {
      return [];
    }
  });

  const isItemRead = (id) => {
    return readIds.includes(Number(id));
  };

  const markAsRead = (id) => {
    const numId = Number(id);
    if (!readIds.includes(numId)) {
      const updated = [...readIds, numId];
      setReadIds(updated);
      localStorage.setItem("read_credit_notifications", JSON.stringify(updated));
    }
  };

  const markAllAsRead = () => {
    const allIds = pendingApprovals.map((r) => Number(r.id));
    const updated = Array.from(new Set([...readIds, ...allIds]));
    setReadIds(updated);
    localStorage.setItem("read_credit_notifications", JSON.stringify(updated));
  };

  const unreadCount = pendingApprovals.filter((req) => !isItemRead(req.id)).length;

  const handleClickAvatar = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogoutClick = () => {
    setAnchorEl(null);
    setLogoutDialogOpen(true);
  };

  const handleLogoutCancel = () => {
    setLogoutDialogOpen(false);
  };

  const handleLogoutConfirm = () => {
    setLogoutDialogOpen(false);
    handleLogout();
  };

  return (
    <Box className="top_sticky_header">
      <AppBar
        // className={`appbar-design ${appBarPosition}`}
        sx={{
          backgroundColor: "#ffffff",
          color: "#1a1a1a",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        }}
      >
        <Toolbar
          disableGutters
          sx={{
            minHeight: "70px",
            px: 3,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginLeft: props.isMobile
              ? "0"
              : props.sidebarOpen
              ? "280px"
              : "70px",
            transition: "margin-left 0.25s ease",
            position: "relative",
          }}
        >
          {/* Left: Menu Toggle Button (positioned beside the sidebar) */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton
              size="large"
              aria-label="toggle menu"
              onClick={() => props.menuAction()}
              sx={{
                color: "#2c3e50",
                position: "fixed",
                left: props.isMobile
                  ? "12px"
                  : props.sidebarOpen
                  ? "300px"
                  : "90px",
                top: "12px",
                zIndex: 10000,
                backgroundColor: "transparent",
                "&:hover": { backgroundColor: "transparent" },
                boxShadow: "none",
                p: 0.5,
              }}
            >
              {props.menuOpenedFlag ? (
                <MenuIcon sx={{ height: "28px", width: "28px" }} />
              ) : (
                <MenuOpenIcon sx={{ height: "28px", width: "28px" }} />
              )}
            </IconButton>
          </Box>

          {/* Right: Notifications & User Profile */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            {isAdmin && (
              <>
                <Tooltip title="Credit Approval Notifications">
                  <IconButton
                    size="medium"
                    onClick={(e) => setNotificationsAnchor(e.currentTarget)}
                    sx={{ color: "#475569" }}
                  >
                    <Badge badgeContent={unreadCount} color="error">
                      <NotificationsIcon />
                    </Badge>
                  </IconButton>
                </Tooltip>

                {/* Notifications Menu */}
                <Menu
                  anchorEl={notificationsAnchor}
                  open={isNotificationOpen}
                  onClose={() => setNotificationsAnchor(null)}
                  PaperProps={{
                    elevation: 3,
                    sx: {
                      width: 360,
                      maxWidth: "100%",
                      borderRadius: "12px",
                      mt: 1.5,
                      p: 1,
                    },
                  }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                >
                  <Box sx={{ px: 2, py: 1.5, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography variant="subtitle1" fontWeight={700}>
                      Credit Approval Requests
                    </Typography>
                    {unreadCount > 0 ? (
                      <Button
                        size="small"
                        onClick={markAllAsRead}
                        sx={{ textTransform: "none", fontSize: "0.75rem" }}
                      >
                        Mark all as read
                      </Button>
                    ) : pendingApprovals.length > 0 ? (
                      <Typography variant="caption" color="text.secondary">
                        All read
                      </Typography>
                    ) : null}
                  </Box>
                  <Divider />

                  {pendingApprovals.length === 0 ? (
                    <Box sx={{ p: 3, textAlign: "center" }}>
                      <Typography variant="body2" color="text.secondary">
                        No pending credit approval requests.
                      </Typography>
                    </Box>
                  ) : (
                    pendingApprovals.map((req) => {
                      const isRead = isItemRead(req.id);
                      return (
                        <MenuItem
                          key={req.id}
                          onClick={() => {
                            markAsRead(req.id);
                            setNotificationsAnchor(null);
                            // Per-document requests (invoice / CDN / proforma /
                            // CDN → Invoice) open straight into their Review;
                            // legacy customer-level ones go to the customer.
                            if (req.doc_type) {
                              navigate(`/credit-approval/list?review=${req.id}`);
                            } else if (req.customer_id) {
                              navigate(`/customer/edit/${req.customer_id}`);
                            } else {
                              navigate("/customer/list");
                            }
                          }}
                          sx={{
                            flexDirection: "column",
                            alignItems: "flex-start",
                            py: 1.5,
                            px: 2,
                            gap: 0.5,
                            whiteSpace: "normal",
                            borderBottom: "1px solid #f1f5f9",
                            backgroundColor: isRead ? "#f8fafc" : "#ffffff",
                            opacity: isRead ? 0.65 : 1,
                            borderLeft: isRead ? "3px solid transparent" : "3px solid #1976d2",
                            transition: "all 0.2s ease",
                            "&:hover": {
                              backgroundColor: isRead ? "#f1f5f9" : "#e0f2fe",
                            },
                          }}
                        >
                          <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Typography variant="subtitle2" fontWeight={isRead ? 500 : 700} color={isRead ? "text.secondary" : "primary"}>
                              {req.customer_name || req.company_name}
                            </Typography>
                            {!isRead && (
                              <Box sx={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: "#1976d2" }} />
                            )}
                          </Box>
                          <Typography variant="body2" color={isRead ? "text.secondary" : "text.primary"}>
                            Requested <strong>{req.requested_days} Days</strong> by {req.requester_name || "Sales Exec"}
                          </Typography>
                          {req.doc_type && (
                            <Typography variant="caption" color="text.secondary">
                              {{ invoice: "Invoice", cdn: "CDN", proforma: "Proforma", cdn_convert: "CDN → Invoice" }[req.doc_type] || req.doc_type}
                              {req.doc_number ? ` · ${req.doc_number}` : " · draft"}
                            </Typography>
                          )}
                          {req.notes && (
                            <Typography variant="caption" color="text.secondary" sx={{ fontStyle: "italic" }}>
                              "{req.notes}"
                            </Typography>
                          )}
                          <Box sx={{ display: "flex", gap: 0.8, mt: 1, flexWrap: "wrap" }}>
                            <Button
                              size="small"
                              variant="contained"
                              color="success"
                              sx={{ textTransform: "none", borderRadius: 1.5, fontSize: "0.75rem", py: 0.5, px: 1 }}
                              onClick={async (e) => {
                                e.stopPropagation();
                                try {
                                  const res = await apiData("post", approveCreditApprovalAPI, {
                                    requestId: req.id,
                                    approved_days: req.requested_days,
                                  });
                                  if (res?.success) {
                                    markAsRead(req.id);
                                    fetchNotifications();
                                  }
                                } catch (err) {
                                  console.error("Failed to approve request:", err);
                                }
                              }}
                            >
                              Approve ({req.requested_days} Days)
                            </Button>
                            <Button
                              size="small"
                              variant="outlined"
                              color="warning"
                              sx={{ textTransform: "none", borderRadius: 1.5, fontSize: "0.75rem", py: 0.5, px: 1 }}
                              onClick={(e) => {
                                e.stopPropagation();
                                setNotificationsAnchor(null);
                                setCustomDaysModal({
                                  open: true,
                                  req: req,
                                  days: req.requested_days || "",
                                  loading: false,
                                });
                              }}
                            >
                              Edit Days
                            </Button>
                            {/* <Button
                              size="small"
                              variant={isRead ? "text" : "outlined"}
                              color="primary"
                              sx={{ textTransform: "none", borderRadius: 1.5, fontSize: "0.75rem", py: 0.5, px: 1 }}
                              onClick={(e) => {
                                e.stopPropagation();
                                markAsRead(req.id);
                                setNotificationsAnchor(null);
                                if (req.customer_id) {
                                  navigate(`/customer/edit/${req.customer_id}`);
                                } else {
                                  navigate("/customer/list");
                                }
                              }}
                            >
                              Configure Master
                            </Button> */}
                          </Box>
                        </MenuItem>
                      );
                    })
                  )}
                  <Box sx={{ p: 1.5, textAlign: "center", borderTop: "1px solid #f1f5f9", backgroundColor: "#f8fafc" }}>
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      size="small"
                      sx={{ textTransform: "none", borderRadius: 2, fontWeight: 600 }}
                      onClick={() => {
                        setNotificationsAnchor(null);
                        navigate("/credit-approval/list");
                      }}
                    >
                      View All Credit Approvals
                    </Button>
                  </Box>
                </Menu>
              </>
            )}

            <IconButton
              onClick={handleClickAvatar}
              size="medium"
              sx={{
                padding: "6px",
                "&:hover": {
                  backgroundColor: "transparent !important",
                },
                "&:active": {
                  backgroundColor: "transparent !important",
                },
              }}
              aria-controls={open ? "account-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            >
              <UserAvatar name={userName} email={userEmail} />
            </IconButton>
          </Box>

          {/* User Profile Menu */}
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 3,
              sx: {
                overflow: "visible",
                minWidth: "280px",
                mt: 6,
                borderRadius: "12px",
                border: "1px solid rgba(0,0,0,0.08)",
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            {/* User Info Section */}
            <Box sx={{ px: 2.5, py: 2, textAlign: "center" }}>
              <Typography
                variant="subtitle1"
                fontWeight={600}
                sx={{ color: "#1a1a1a", mb: 0.5 }}
              >
                {userData.username}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "#64748b", fontSize: "0.875rem", mb: 0.5 }}
              >
                {userData.position_name}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "#94a3b8", fontSize: "0.8125rem" }}
              >
                {userData.email}
              </Typography>
            </Box>

            <Divider sx={{ my: 1 }} />

            {/* View Profile Option */}
            <MenuItem
              onClick={() => {
                handleClose();
                navigate(`/employee/view/${userData.emp_id}`);
              }}
              sx={{
                px: 2.5,
                py: 1.5,
                gap: 1.5,
                "&:hover": {
                  backgroundColor: "rgba(99, 102, 241, 0.08)",
                },
              }}
            >
              <PersonIcon sx={{ fontSize: 20, color: "#6366f1" }} />
              <Typography variant="body2" fontWeight={500}>
                View Profile
              </Typography>
            </MenuItem>

            <Divider sx={{ my: 1 }} />

            {/* Logout Option */}
            <MenuItem
              onClick={handleLogoutClick}
              sx={{
                px: 2.5,
                py: 1.5,
                gap: 1.5,
                color: "#ef4444",
                "&:hover": {
                  backgroundColor: "rgba(239, 68, 68, 0.08)",
                },
              }}
            >
              <LogoutIcon sx={{ fontSize: 20 }} />
              <Typography variant="body2" fontWeight={500}>
                Logout
              </Typography>
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      {/* Custom Credit Days Approval Dialog */}
      <Dialog
        open={customDaysModal.open}
        onClose={() => setCustomDaysModal((prev) => ({ ...prev, open: false }))}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: "bold", fontSize: "1.1rem" }}>
          Approve Credit Days
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1 }}>
            <Typography variant="body2">
              Customer: <strong>{customDaysModal.req?.customer_name || customDaysModal.req?.company_name}</strong>
            </Typography>
            <Typography variant="body2">
              Requested by: <strong>{customDaysModal.req?.requester_name || "Sales Exec"}</strong> ({customDaysModal.req?.requested_days} Days)
            </Typography>
            {customDaysModal.req?.notes && (
              <Typography variant="caption" color="text.secondary" sx={{ fontStyle: "italic" }}>
                Reason: "{customDaysModal.req.notes}"
              </Typography>
            )}
            <TextField
              label="Approved Credit Days"
              type="number"
              fullWidth
              value={customDaysModal.days}
              onChange={(e) => setCustomDaysModal((prev) => ({ ...prev, days: e.target.value }))}
              inputProps={{ min: 1 }}
              placeholder="e.g. 7, 10, 15, 30"
              autoFocus
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={() => setCustomDaysModal((prev) => ({ ...prev, open: false }))}
            color="inherit"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="success"
            disabled={!customDaysModal.days || Number(customDaysModal.days) <= 0 || customDaysModal.loading}
            onClick={async () => {
              try {
                setCustomDaysModal((prev) => ({ ...prev, loading: true }));
                const res = await apiData("post", approveCreditApprovalAPI, {
                  requestId: customDaysModal.req?.id,
                  approved_days: Number(customDaysModal.days),
                });
                if (res?.success) {
                  if (customDaysModal.req?.id) markAsRead(customDaysModal.req.id);
                  fetchNotifications();
                  setCustomDaysModal({ open: false, req: null, days: "", loading: false });
                }
              } catch (err) {
                console.error("Failed to approve custom days:", err);
              } finally {
                setCustomDaysModal((prev) => ({ ...prev, loading: false }));
              }
            }}
          >
            Approve {customDaysModal.days ? `${customDaysModal.days} Days` : ""}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Logout Confirmation Dialog */}
      <Dialog
        open={logoutDialogOpen}
        onClose={handleLogoutCancel}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            padding: "8px",
            minWidth: "400px",
          },
        }}
      >
        <DialogTitle sx={{ pb: 2, fontSize: "1.25rem", fontWeight: 600 }}>
          Confirm Logout
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ color: "#64748b" }}>
            Are you sure you want to logout?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
          <Button
            onClick={handleLogoutCancel}
            variant="outlined"
            sx={{
              textTransform: "none",
              borderRadius: "8px",
              px: 3,
              py: 1,
              borderColor: "#e2e8f0",
              color: "#64748b",
              "&:hover": {
                borderColor: "#cbd5e1",
                backgroundColor: "#f8fafc",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleLogoutConfirm}
            variant="contained"
            sx={{
              textTransform: "none",
              borderRadius: "8px",
              px: 3,
              py: 1,
              backgroundColor: "#ef4444",
              "&:hover": {
                backgroundColor: "#dc2626",
              },
            }}
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default Header;
